import React, { useEffect, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { T } from 'shared/helper/translate';
var messageProperties = function messageProperties(message, onClose) {
  return {
    autoClose: 8000,
    position: 'bottom-center',
    onClose: onClose,
    type: message.type,
    render: /*#__PURE__*/React.createElement(T, {
      source: message.message,
      params: message.params || {}
    })
  };
};
var EphemeralFlashMessage = function EphemeralFlashMessage(_ref) {
  var dismissMessage = _ref.dismissMessage,
    message = _ref.message;
  var toastId = useRef(null);
  useEffect(function () {
    toastId.current = toast(/*#__PURE__*/React.createElement(T, {
      source: message.message,
      params: message.params || {}
    }), messageProperties(message, dismissMessage));
  }, []);
  useEffect(function () {
    if (toastId.current) {
      toast.update(toastId.current, messageProperties(message, dismissMessage));
    }
  }, [message.message]);
  return /*#__PURE__*/React.createElement(ToastContainer, null);
};
export default EphemeralFlashMessage;